import { Routes } from '@angular/router';
import { ErrorPageComponent } from './error-page/error-page.component';
import { SecretKeyPageComponent } from './secret-key-page/secret-key-page.component';
import { LayoutComponent } from './traceability-shell/layout/layout.component';

export const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    // TODO:
    // refactor to:
    loadChildren: () =>
      import('./traceability-shell/traceability-shell.routes').then(
        (m) => m.TRACEABILITY_SHELL_ROUTES
      )
  },
  {
    path: 'token/:token',
    component: LayoutComponent,
    // TODO:
    // refactor to:
    loadChildren: () =>
      import('./traceability-shell/traceability-shell.routes').then(
        (m) => m.TRACEABILITY_SHELL_ROUTES
      )
  },
  {
    path: 'offplatformsiview/:si_numb',
    redirectTo: 'secret-key',
    pathMatch: 'full'
  },
  { path: 'offplatformsiview', component: SecretKeyPageComponent },
  {
    path: 'token/:token',
    children: [
      {
        path: 'language/:language',
        component: LayoutComponent,
        // TODO
        loadChildren: () =>
          import('./traceability-shell/traceability-shell.routes').then(
            (m) => m.TRACEABILITY_SHELL_ROUTES
          )
      }
    ]
  },
  {
    path: 'error',
    component: ErrorPageComponent
  },
  { path: '**', redirectTo: 'error' }
];
